import ModelFactory from '../model-factory';

/**
 * format:
{
  @COMMON_NAME: "<p><a href="https://urldefense.proofpoint.com/v2/url?u=https-3A__web.sas.junta-2Dandalucia.es_servicioandaluzdesalud_profesionales_recursos-2Dpara-2Dprofesionales_procedimiento-2Dpara-2Dteletrabajar&d=DwMD-g&c=eIGjsITfXP_y-DLLX0uEHXJvU8nOHrUK8IrwNKOtkVU&r=-h0CDQBmisAfOe-GYeXdAIse3m97Qsfbji1inJGEQ8U&m=mRzWl282TvXkrVqFvHFrIGTWw-gBtGgT5uwQd5S5Ssw&s=XpNrC0y430H4-BbED_6_1oW9h041mLNaFzguSgpcWQc&e=" target="_blank">Pulsa aquí para consultar toda la información relativa a la modalidad no presencial de trabajo.</a></p>"
  @REL_ATTR: 400866
  @id: 400866
}
 */

export default class Announcement {
  constructor(data = {}) {
    // console.log('datarow', data);

    this.id = data['@id'] || null;
    this.name = data['@COMMON_NAME'] || null;
  }
}

export const modelFactory = new ModelFactory('cnote', (data) => new Announcement(data));
